import "core-js/modules/es.symbol.js";
import "core-js/modules/es.symbol.description.js";
import "core-js/modules/es.object.to-string.js";
import "core-js/modules/es.symbol.iterator.js";
import "core-js/modules/es.array.iterator.js";
import "core-js/modules/es.string.iterator.js";
import "core-js/modules/web.dom-collections.iterator.js";
import "core-js/modules/es.array.slice.js";
import "core-js/modules/es.array.from.js";
import "core-js/modules/es.regexp.exec.js";
import "core-js/modules/es.object.keys.js";
import "core-js/modules/es.array.filter.js";
import "core-js/modules/es.object.get-own-property-descriptor.js";
import "core-js/modules/web.dom-collections.for-each.js";
import "core-js/modules/es.object.get-own-property-descriptors.js";
import _capitalize from "lodash/capitalize";
var _excluded = ["text", "buttonAttributes"],
  _excluded2 = ["text", "url", "type"];
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import "core-js/modules/es.array.map.js";
function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }
function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { _defineProperty(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }
function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
function _slicedToArray(arr, i) { return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _unsupportedIterableToArray(arr, i) || _nonIterableRest(); }
function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }
function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) { arr2[i] = arr[i]; } return arr2; }
function _iterableToArrayLimit(arr, i) { var _i = arr == null ? null : typeof Symbol !== "undefined" && arr[Symbol.iterator] || arr["@@iterator"]; if (_i == null) return; var _arr = []; var _n = true; var _d = false; var _s, _e; try { for (_i = _i.call(arr); !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"] != null) _i["return"](); } finally { if (_d) throw _e; } } return _arr; }
function _arrayWithHoles(arr) { if (Array.isArray(arr)) return arr; }
import { useEffect, useState, useRef } from 'react';
import classnames from 'classnames';
import { Background } from "../../Background/Background";
import { Breakpoints } from "../../Responsive/Breakpoints/Breakpoints";
import { Button } from "../../Button/Button/Button";
import { Container } from "../../Container/Container/Container";
import { HeadingText } from "../../Text/HeadingText/HeadingText";
import { Image } from "../../Image/Image/Image";
import { Theme } from "../../Background/Theme/Theme";
import { Text } from "../../Text/Text/Text";
import { ScrollTransform } from "../../ScrollTransform/ScrollTransform";
import SwiperCore, { Navigation, Pagination, A11y } from 'swiper';
import { Swiper as SwiperClass, SwiperSlide } from 'swiper/react';
import 'swiper/swiper-bundle.min.css';
import styles from "./HomepageCarouselSlice.module.scss";
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
import { Fragment as _Fragment } from "react/jsx-runtime";
SwiperCore.use([Navigation, Pagination, A11y]);
export var homepageCarouselSlideBgColors = ['#181877',
// WW100
'#00351C',
// WW300
'#FE8458' // WW400
];
export var homepageCarouselEyebrowTypogs = ['eyebrow1', 'eyebrow2', 'eyebrow3'];
export var homepageCarouselImageAlign = ['right', 'left'];
export var carouselVersions = ['default', 'testimonial'];
var carouselVertOffsetDesktop = 16;
var carouselPadding = 50;
var desktopImageHeight = 582;
var featureImageVertOffset = 130;
var defaultSubheadingTypog = 'headline5';
var defaultEyebrowTypog = 'eyebrow3';
var defaultHeadingTypog = 'headline3';
export var HomepageCarouselSlice = function HomepageCarouselSlice(_ref) {
  var _currentSlideIcon$ico, _currentSlideIcon$ico2;
  var isMember = _ref.isMember,
    icon = _ref.icon,
    _ref$eyebrow = _ref.eyebrow,
    eyebrow = _ref$eyebrow === void 0 ? {
      text: '',
      typog: defaultEyebrowTypog,
      variant: 'default'
    } : _ref$eyebrow,
    _ref$heading = _ref.heading,
    heading = _ref$heading === void 0 ? {
      ariaLevel: 3,
      text: '',
      typog: defaultHeadingTypog,
      variant: 'default'
    } : _ref$heading,
    _ref$subheading = _ref.subheading,
    subheading = _ref$subheading === void 0 ? {
      typog: defaultSubheadingTypog,
      text: '',
      ariaLevel: 4,
      variant: 'default'
    } : _ref$subheading,
    button = _ref.button,
    _ref$footnote = _ref.footnote,
    footnote = _ref$footnote === void 0 ? '' : _ref$footnote,
    _ref$scrollTransformB = _ref.scrollTransformBodyScale,
    scrollTransformBodyScale = _ref$scrollTransformB === void 0 ? false : _ref$scrollTransformB,
    slides = _ref.slides,
    _ref$imageAlignment = _ref.imageAlignment,
    imageAlignment = _ref$imageAlignment === void 0 ? 'right' : _ref$imageAlignment,
    _ref$carouselVersion = _ref.carouselVersion,
    carouselVersion = _ref$carouselVersion === void 0 ? 'default' : _ref$carouselVersion,
    background = _ref.background,
    _ref$theme = _ref.theme,
    theme = _ref$theme === void 0 ? 'lightBackground' : _ref$theme,
    _ref$orderedList = _ref.orderedList,
    orderedList = _ref$orderedList === void 0 ? false : _ref$orderedList,
    _ref$onSwipe = _ref.onSwipe,
    onSwipe = _ref$onSwipe === void 0 ? function () {} : _ref$onSwipe;
  var _useState = useState(0),
    _useState2 = _slicedToArray(_useState, 2),
    backgroundColorHeight = _useState2[0],
    setBackgroundColorHeight = _useState2[1];
  var _useState3 = useState(0),
    _useState4 = _slicedToArray(_useState3, 2),
    carouselTop = _useState4[0],
    setCarouselTop = _useState4[1];
  var _useState5 = useState(0),
    _useState6 = _slicedToArray(_useState5, 2),
    currId = _useState6[0],
    setCurrId = _useState6[1];
  var _useState7 = useState(''),
    _useState8 = _slicedToArray(_useState7, 2),
    direction = _useState8[0],
    setDirection = _useState8[1];
  var _useState9 = useState(0),
    _useState10 = _slicedToArray(_useState9, 2),
    sliceHeight = _useState10[0],
    setSliceHeight = _useState10[1];
  var _useState11 = useState(0),
    _useState12 = _slicedToArray(_useState11, 2),
    setRerenderKey = _useState12[1];
  var carouselConfig = useRef({
    slidesPerView: 3,
    centeredSlides: true,
    loop: true,
    grabCursor: true,
    pagination: {
      clickable: true,
      el: '.swiper-pagination'
    },
    navigation: {
      nextEl: '.swiper-button-next',
      prevEl: '.swiper-button-prev'
    },
    onSlideChangeTransitionStart: function onSlideChangeTransitionStart() {
      onSwipe();
    },
    onSlidePrevTransitionStart: function onSlidePrevTransitionStart() {
      return setDirection('previous');
    },
    onSlideNextTransitionStart: function onSlideNextTransitionStart() {
      return setDirection('next');
    },
    onSlideChangeTransitionEnd: function onSlideChangeTransitionEnd(swiper) {
      return updateContent(swiper.realIndex);
    },
    breakpoints: {
      320: {
        spaceBetween: carouselVersion === 'testimonial' ? 16 : 115
      },
      768: {
        centeredSlides: orderedList ? false : true,
        spaceBetween: carouselVersion === 'testimonial' ? 24 : 115
      }
    }
  });
  var contentRef = useRef(null);
  var carouselRef = useRef(null);
  useEffect(function () {
    setRerenderKey(function (prevKey) {
      return prevKey + 1;
    });
    carouselConfig.current = _objectSpread(_objectSpread({}, carouselConfig.current), {}, {
      centeredSlides: Breakpoints.medium.min < window.innerWidth && orderedList ? false : true
    });
  }, [orderedList]);
  useEffect(function () {
    if (window) {
      setCarouselPos();
      window.addEventListener('resize', setCarouselPos);
    }
    return function () {
      if (window) {
        window.removeEventListener('resize', setCarouselPos);
      }
    };
  }, []);
  var setCarouselPos = function setCarouselPos() {
    setBackgroundColorHeight(contentRef.current ? contentRef.current.getBoundingClientRect().height : null);
    setCarouselTop(contentRef.current ? Breakpoints.medium.min > window.innerWidth ?
    // Mobile.
    contentRef.current.getBoundingClientRect().height :
    // Desktop.
    carouselVertOffsetDesktop : null);
    setSliceHeight(contentRef.current && carouselRef.current ? Breakpoints.medium.min > window.innerWidth ?
    // Mobile.
    contentRef.current.getBoundingClientRect().height + carouselRef.current.getBoundingClientRect().height + carouselPadding :
    // Desktop - If content height (text fields and CTA) is greater than carousel height...
    contentRef.current.getBoundingClientRect().height > carouselRef.current.getBoundingClientRect().height ?
    // Use content height + padding.
    contentRef.current.getBoundingClientRect().height + carouselPadding :
    // Use carousel attributes + padding.
    carouselVertOffsetDesktop + desktopImageHeight + featureImageVertOffset + carouselPadding : null);
  };
  var renderCarouselItems = function renderCarouselItems(carouselVersion) {
    //
    return slides === null || slides === void 0 ? void 0 : slides.map(function (item, key) {
      var alignment = !imageAlignment ? 'right' : imageAlignment;
      var image = slides[key].image;
      var testimonialField = slides[key].testimonialField;
      return /*#__PURE__*/_jsx(SwiperSlide, {
        children: function children(renderProps) {
          var isPrev = renderProps.isPrev;
          var isActive = renderProps.isActive;
          var isNext = renderProps.isNext;
          if (carouselVersion === 'testimonial') {
            return /*#__PURE__*/_jsx(Theme, {
              theme: "lightBackground",
              children: /*#__PURE__*/_jsxs("div", {
                className: classnames(styles.slide, styles.slideMember),
                children: [/*#__PURE__*/_jsx(Image, _objectSpread({}, image)), (testimonialField === null || testimonialField === void 0 ? void 0 : testimonialField.quote) && /*#__PURE__*/_jsxs("div", {
                  className: styles.testimonialTextField,
                  children: [/*#__PURE__*/_jsx(Text, {
                    typog: 'bodycopy',
                    className: styles.testimonialQuote,
                    children: testimonialField.quote
                  }), /*#__PURE__*/_jsxs("div", {
                    className: styles.testimonialNameWeight,
                    children: [/*#__PURE__*/_jsx(Text, {
                      typog: 'subhead3',
                      className: styles.testimonialName,
                      textElement: 'span',
                      children: testimonialField.name
                    }), /*#__PURE__*/_jsx(Text, {
                      typog: 'headline6',
                      className: styles.testimonialWeight,
                      textElement: 'span',
                      children: testimonialField.weight
                    })]
                  })]
                })]
              })
            });
          }
          return /*#__PURE__*/_jsx("div", {
            className: classnames(styles.slide, isPrev && styles.slidePrev, isActive && styles.slideActive, isActive && direction === 'previous' && styles.slideActivePrevious, isActive && alignment && styles["slideActive".concat(_capitalize(alignment))], isMember && styles.slideMember, isNext && styles.slideNext),
            children: /*#__PURE__*/_jsx(Image, _objectSpread(_objectSpread({}, image), {}, {
              transformations: {
                image1x: {
                  width: 298
                },
                image2x: {
                  width: 560
                }
              }
            }))
          });
        }
      }, key);
    });
  };
  var renderCTA = function renderCTA(cta) {
    var text = cta.text,
      _cta$buttonAttributes = cta.buttonAttributes,
      buttonAttributes = _cta$buttonAttributes === void 0 ? {} : _cta$buttonAttributes,
      otherProps = _objectWithoutProperties(cta, _excluded);
    return /*#__PURE__*/_jsx(Button, _objectSpread(_objectSpread({
      attributes: buttonAttributes
    }, otherProps), {}, {
      children: text
    }));
  };
  var renderButton = function renderButton(button) {
    var _ref2 = button || {},
      text = _ref2.text,
      url = _ref2.url,
      type = _ref2.type,
      otherProps = _objectWithoutProperties(_ref2, _excluded2);
    return /*#__PURE__*/_jsx(Button, _objectSpread(_objectSpread({
      url: url,
      type: type
    }, otherProps), {}, {
      children: text
    }));
  };
  var renderSubheading = function renderSubheading() {
    var subheadingComponent = /*#__PURE__*/_jsx("div", {
      className: classnames(styles.subheading),
      children: /*#__PURE__*/_jsx(HeadingText, {
        align: "center",
        typog: subheading !== null && subheading !== void 0 && subheading.typog ? subheading.typog : defaultSubheadingTypog,
        ariaLevel: subheading.ariaLevel,
        variant: subheading.variant,
        children: subheading.text
      })
    });
    var scrollTransform = {
      startScrollPercent: 0,
      endScrollPercent: 0.5,
      transforms: [{
        transformFunction: 'scaleX',
        unit: '',
        startValue: 0.75,
        endValue: 1
      }, {
        transformFunction: 'scaleY',
        unit: '',
        startValue: 0.75,
        endValue: 1
      }]
    };
    return scrollTransformBodyScale ? /*#__PURE__*/_jsx(ScrollTransform, _objectSpread(_objectSpread({}, scrollTransform), {}, {
      children: subheadingComponent
    })) : subheadingComponent;
  };
  var updateContent = function updateContent(id) {
    setCurrId(id);
  };
  var currentSlide = slides ? slides[currId] ? slides[currId] : slides[0] : {};
  var backgroundColor = currentSlide.backgroundColor,
    bodyText = currentSlide.bodyText,
    cta = currentSlide.cta,
    currentSlideEyebrow = currentSlide.eyebrow,
    headline = currentSlide.headline,
    currentSlideIcon = currentSlide.icon;
  var alignment = !imageAlignment ? 'right' : imageAlignment;
  return /*#__PURE__*/_jsxs(Background, {
    theme: theme,
    color: background,
    children: [/*#__PURE__*/_jsx(Container, {
      children: ((heading === null || heading === void 0 ? void 0 : heading.text) || (subheading === null || subheading === void 0 ? void 0 : subheading.text) || (eyebrow === null || eyebrow === void 0 ? void 0 : eyebrow.text) || icon || button) && /*#__PURE__*/_jsxs("div", {
        className: classnames(styles.introWrapper, carouselVersion === 'testimonial' && styles.introRedesign),
        children: [(icon === null || icon === void 0 ? void 0 : icon.image1x) && /*#__PURE__*/_jsx("div", {
          className: classnames(styles.sliceicon),
          children: /*#__PURE__*/_jsx(Image, {
            alt: icon.alt,
            src: icon.image1x,
            width: icon.width || undefined,
            height: icon.height || undefined,
            loading: icon.loading || 'lazy',
            transformations: {
              image1x: {
                width: icon.width ? parseInt(icon.width, 10) || undefined : undefined
              },
              image2x: {
                width: icon.width ? parseInt(icon.width, 10) * 2 || undefined : undefined
              }
            },
            forceTwoXInSrc: true
          })
        }), eyebrow.text && /*#__PURE__*/_jsx(Text, {
          className: styles.slicebrow,
          typog: eyebrow !== null && eyebrow !== void 0 && eyebrow.typog ? eyebrow.typog : defaultEyebrowTypog,
          variant: eyebrow.variant,
          children: eyebrow.text
        }), heading.text && /*#__PURE__*/_jsx("div", {
          className: styles.heading,
          children: /*#__PURE__*/_jsx(HeadingText, {
            align: "center",
            typog: heading !== null && heading !== void 0 && heading.typog ? heading.typog : defaultHeadingTypog,
            ariaLevel: heading.ariaLevel,
            variant: heading.variant,
            children: heading.text
          })
        }), subheading.text && renderSubheading(), (button === null || button === void 0 ? void 0 : button.text) && /*#__PURE__*/_jsx("div", {
          className: styles.buttonWrapper,
          children: /*#__PURE__*/_jsx("div", {
            className: classnames(styles.button),
            "data-e2e-name": "homepage_carousel_cta",
            children: renderButton(button)
          })
        })]
      })
    }), /*#__PURE__*/_jsxs("div", {
      className: classnames(styles.wrapper, carouselVersion === 'testimonial' && styles.testimonial, theme === 'darkBackground' && styles.darkBackground),
      style: {
        height: sliceHeight !== null && sliceHeight !== void 0 ? sliceHeight : undefined
      },
      children: [carouselVersion !== 'testimonial' && /*#__PURE__*/_jsx("div", {
        className: classnames(styles.background),
        style: {
          backgroundColor: backgroundColor,
          height: backgroundColorHeight !== null && backgroundColorHeight !== void 0 ? backgroundColorHeight : undefined
        },
        children: /*#__PURE__*/_jsx(Container, {
          children: /*#__PURE__*/_jsx(Theme, {
            theme: "darkBackground",
            children: /*#__PURE__*/_jsx("div", {
              className: classnames(styles.contentWrapper, alignment && styles["contentWrapper".concat(_capitalize(alignment), "Alignment")]),
              children: /*#__PURE__*/_jsxs("div", {
                className: styles.content,
                ref: contentRef,
                children: [(currentSlideEyebrow === null || currentSlideEyebrow === void 0 ? void 0 : currentSlideEyebrow.text) && /*#__PURE__*/_jsx(Text, {
                  className: styles.eyebrow,
                  typog: "eyebrow1",
                  children: currentSlideEyebrow.text
                }), (headline === null || headline === void 0 ? void 0 : headline.text) && /*#__PURE__*/_jsx("div", {
                  className: styles.headline,
                  children: /*#__PURE__*/_jsx(HeadingText, {
                    typog: "subhead1",
                    align: "left",
                    children: headline.text
                  })
                }), bodyText && /*#__PURE__*/_jsx("div", {
                  className: styles.body,
                  children: /*#__PURE__*/_jsx(Text, {
                    richText: true,
                    typog: "headline4",
                    "data-e2e-name": "carousel_body_text",
                    children: bodyText
                  })
                }), (currentSlideIcon === null || currentSlideIcon === void 0 ? void 0 : (_currentSlideIcon$ico = currentSlideIcon.icon) === null || _currentSlideIcon$ico === void 0 ? void 0 : _currentSlideIcon$ico.source.url) && currentSlideIcon.text && /*#__PURE__*/_jsxs("div", {
                  className: styles.icon,
                  children: [/*#__PURE__*/_jsx(Image, {
                    src: (currentSlideIcon === null || currentSlideIcon === void 0 ? void 0 : (_currentSlideIcon$ico2 = currentSlideIcon.icon) === null || _currentSlideIcon$ico2 === void 0 ? void 0 : _currentSlideIcon$ico2.source.url) || '',
                    width: "24px",
                    height: "24px",
                    className: styles.fileIcon
                  }), /*#__PURE__*/_jsx(Text, {
                    className: styles.iconText,
                    richText: true,
                    typog: "bodycopy",
                    "data-e2e-name": "carousel_info_text",
                    children: currentSlideIcon.text
                  })]
                }), (cta === null || cta === void 0 ? void 0 : cta.text) && (cta === null || cta === void 0 ? void 0 : cta.url) && /*#__PURE__*/_jsx("div", {
                  className: styles.cta,
                  children: renderCTA(cta)
                })]
              })
            })
          })
        })
      }), /*#__PURE__*/_jsxs("div", {
        ref: carouselRef,
        className: styles.carouselWrapper,
        style: {
          top: carouselTop !== null && carouselTop !== void 0 ? carouselTop : undefined
        },
        children: [carouselVersion === 'testimonial' && /*#__PURE__*/_jsxs(_Fragment, {
          children: [/*#__PURE__*/_jsx("div", {
            className: classnames('swiper-button-next', styles.navigation, styles.navigationNext)
          }), /*#__PURE__*/_jsx("div", {
            className: classnames('swiper-button-prev', styles.navigation, styles.navigationPrev)
          })]
        }), /*#__PURE__*/_jsx("div", {
          className: styles.carousel,
          children: /*#__PURE__*/_jsxs(SwiperClass, _objectSpread(_objectSpread({}, carouselConfig.current), {}, {
            children: [renderCarouselItems(carouselVersion), carouselVersion !== 'testimonial' && /*#__PURE__*/_jsxs(_Fragment, {
              children: [/*#__PURE__*/_jsx("div", {
                className: classnames('swiper-button-next', styles.navigation, styles.navigationNext)
              }), /*#__PURE__*/_jsx("div", {
                className: classnames('swiper-button-prev', styles.navigation, styles.navigationPrev)
              })]
            }), /*#__PURE__*/_jsx("div", {
              className: classnames('swiper-pagination', styles.pagination)
            })]
          }))
        })]
      })]
    }), footnote && /*#__PURE__*/_jsx(Container, {
      children: /*#__PURE__*/_jsx("div", {
        className: classnames(styles.footnote, carouselVersion === 'testimonial' && styles.footnoteRedesign),
        children: /*#__PURE__*/_jsx(Text, {
          className: styles.text,
          typog: "bodycopySmall",
          "data-e2e-name": "carousel_footnote_text",
          children: footnote
        })
      })
    })]
  });
};